<template>
  <div class="solution">
    <topbar :imp="navText"></topbar>
    <img class="ban" src="./img/ban.jpg">
    <div class="wrap">
      <div class="conTitle">解决方案</div>
      <div class="conTitle_bor"></div>
      <div class="conText">航数智能核心技术广泛应用于航空、风电、机床、钻机、高铁、油田等多个领域。</div>
    </div>
    <div class="wrap soluWrap">
      <div class="solu">
        <img src="./img/solu1.jpg">
        <h6>航空</h6>
        <p>航空工业是国家的战略性产业，既是一个国家国防安全的重要基础，也体现了一个国家的工业发展程度，是一个国家综合国力的体现。物联网技术可以对航空制造业从生产、管理到整个流程都进行优化与改进。</p>
      </div>
      <div class="solu">
        <img src="./img/solu2.jpg">
        <h6>风电</h6>
        <p>我国风电设备制造业刚兴起不久，产业链发展并不是很完善，风电整机制造受关键零部件瓶颈制约较为严重。中国电力行业发展正处于大转型的关键时期。物联网成为了风电公司信息化规划的重要组成部分。</p>
      </div>
      <div class="solu">
        <img src="./img/solu3.jpg">
        <h6>机床</h6>
        <p>工业正在实现从“中国制造”向“中国智造”的转型。机床作为“工业母机”，在智能制造趋势中将获得巨大历史机遇。物联网技术对于工业智能化转型、传统制造型企业转型为智能制造服务商、促进智能工厂的发展等都具有重要影响。</p>
      </div>
    </div>
    <div class="wrap soluWrap" id="soluWrapLast">
      <div class="solu">
        <img src="./img/solu4.jpg">
        <h6>钻机</h6>
        <p>石油钻机作为勘探开发的主要设备,勘探作业中的安全监控在整个勘探开发中尤其重要，物联网的全面感知技术可实时监测钻机的作业过程，智能报警和智能分析既可以保证钻机的安全运行，还可以提高开发效率。</p>
      </div>
      <div class="solu">
        <img src="./img/solu5.jpg">
        <h6>高铁</h6>
        <p>中国铁路运输的需求越来越大，尤其是中国高铁已经形成一个世界上规模最大、发展最快的轨道交通建设市场。物联网技术在行车故障监测、系统安全运营、节能减耗、综合绩效管理等各方面都将发挥重要作用。</p>
      </div>
      <div class="solu">
        <img src="./img/solu6.jpg">
        <h6>油田</h6>
        <p>石油需求的增长和高油价推动了市场对油田服务的需求，进而推动我国油田服务行业进入全新发展阶段。物联网的全面感知、可靠传输、和智能应用对于石油开采的安全监测具有重要作用。</p>
      </div>
    </div>
    <botcon></botcon>
  </div>
</template>

<script>
import Topbar from '@/components/base/Topbar/index'
import Botcon from '@/components/base/Botcon/index'
export default {
  name: 'Solution',
  components: {
    Topbar,
    Botcon
  },
  data () {
    return {
      navText: {
        text: '解决方案'
      }
    }
  },
  created () {
    this.$nextTick(() => {
      setTimeout(() => {
        let r = window.innerWidth - document.body.clientWidth
        this.$store.commit('setScroll', r)
      }, 20)
    })
    this.menu()
  },
  methods: {
    menu () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ban{ display: block; width: 100%; height: auto;}
.conTitle{ height: 180px; text-align: center; font-size: 50px; line-height: 52px; padding-top: 83px; color: #3e3e3e;}
.conTitle_bor{ width: 90px; height: 1px; margin: 0 auto; background: #ccc;}
.conText{ padding: 20px 130px 50px; color: #5e5e5e; font-size: 22px; line-height: 40px;font-weight: lighter;}

.soluWrap{ height: 639px; display: flex; justify-content:space-between;}
#soluWrapLast{ height: 669px;}
.solu{ width: 380px; height: 639px;}
.solu img{ width: 380px; height: 380px; display: block;}
.solu h6{ font-size: 26px; color: #3e3e3e; line-height: 60px; padding-top: 10px;}
.solu p{ font-size: 18px; color: #3e3e3e; line-height: 26px;}
</style>



// WEBPACK FOOTER //
// src/components/Solution/index.vue